import { githubFetch } from './client';

export interface GitHubUserOrganizationListParams {
  per_page?: number;
  cursor?: string;
}

export interface GitHubOrganization {
  login: string;
  id: number;
  avatar_url: string;
  description: string | null;
}

export interface GitHubUserOrganizationListResponse {
  organizations: GitHubOrganization[];
  cursor?: string;
}

export async function githubUserOrganizationList(
  params: GitHubUserOrganizationListParams = {}
): Promise<GitHubUserOrganizationListResponse> {
  return githubFetch<GitHubUserOrganizationListResponse>(
    '/rpc/github_user_organization_list',
    {
      body: params,
    }
  );
}
